import { ChangeDetectionStrategy, Component, inject, linkedSignal } from '@angular/core';
import { TranslationService } from '../../../core/i18n/translation';
import { ToastService } from '../../../core/toast/toast';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast {
  protected readonly toasts = inject(ToastService);
  protected readonly i18n = inject(TranslationService);

  /** Details start collapsed for every new message. */
  protected readonly expanded = linkedSignal({
    source: this.toasts.message,
    computation: () => false,
  });

  protected toggleDetails(): void {
    const next = !this.expanded();
    this.expanded.set(next);
    // Reading a full error takes longer than the auto-dismiss; close it by hand.
    if (next) this.toasts.hold();
  }
}
